export const Return = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5185 6.69845C15.2374 7.53711 15.1402 8.79971 14.3016 9.51855L8.94139 14.113L14.4142 19.5858C15.1953 20.3669 15.1953 21.6332 14.4142 22.4142C13.6332 23.1953 12.3668 23.1953 11.5858 22.4142L4.58579 15.4143C4.19187 15.0203 3.9801 14.48 4.00148 13.9233C4.02285 13.3666 4.27545 12.8441 4.69842 12.4815L11.6984 6.48152C12.5371 5.76268 13.7997 5.8598 14.5185 6.69845Z"
        fill="#C4B57C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 14C4 12.8954 4.89543 12 6 12H28.994C36.9511 12 43.6787 18.4685 43.9885 26.4222L41.99 26.5L43.9885 26.4219C43.9885 26.422 43.9885 26.4221 43.9885 26.4222C44.3168 34.8293 37.3992 42 28.994 42H11.998C10.8934 42 9.998 41.1046 9.998 40C9.998 38.8954 10.8934 38 11.998 38H28.994C35.1347 38 40.2311 32.7108 39.9915 26.5781L39.9915 26.5778C39.7653 20.7715 34.8029 16 28.994 16H6C4.89543 16 4 15.1046 4 14Z"
        fill="#C4B57C"
      />
    </svg>
  );
};
